import classes from './FooterHeader.module.css';

export default function FooterHeader() {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  return (
    <ul className={classes.linksList} data-testid="footer-links">
      <li className={classes.linkItem} data-testid="footer-link-privacy-policy">
        <a
          className={classes.linkItem_link}
          href={`${baseUrl}privacy`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>
      </li>
      <li className={classes.linkItem} data-testid="footer-link-tos">
        <a
          className={classes.linkItem_link}
          href={`${baseUrl}terms`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms of Service
        </a>
      </li>
      <li className={classes.linkItem} data-testid="footer-link-faq">
        <a
          className={classes.linkItem_link}
          href="http://help.get-betterinsurance.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          FAQ
        </a>
      </li>
      <li className={classes.linkItem} data-testid="footer-link-contact">
        <a
          className={classes.linkItem_link}
          href="https://bettermtg.typeform.com/betterinsurance"
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact Us
        </a>
      </li>
      <li className={classes.linkItem} data-testid="footer-link-claims">
        <a
          className={classes.linkItem_link}
          href="http://help.get-betterinsurance.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Claims
        </a>
      </li>
    </ul>
  );
}
